"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Notification = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _notifications = require("../../constants/notifications");
const Notification = exports.Notification = _propTypes.default.shape({
  ID: _propTypes.default.string,
  testId: _propTypes.default.string,
  text: _propTypes.default.string.isRequired,
  category: _propTypes.default.oneOf(Object.values(_notifications.CATEGORIES)).isRequired,
  isRead: _propTypes.default.bool,
  delay: _propTypes.default.number,
  target: _propTypes.default.oneOf(Object.values(_notifications.TARGETS)).isRequired,
  actions: _propTypes.default.arrayOf(_propTypes.default.shape({
    title: _propTypes.default.string.isRequired,
    uri: _propTypes.default.string,
    newTab: _propTypes.default.oneOfType([_propTypes.default.bool, _propTypes.default.string]),
    callback: _propTypes.default.func
  }))
}).isRequired;